module.exports = __webpack_public_path__ + "img/the-realm-of-facts-cover.8c1ea8d7.jpg";